"use strict";
/* istanbul ignore file */
Object.defineProperty(exports, "__esModule", { value: true });
exports.runTestInFiberContext = exports.testFnWrapper = void 0;
const testFnWrapper_1 = require("./testFnWrapper");
Object.defineProperty(exports, "testFnWrapper", { enumerable: true, get: function () { return testFnWrapper_1.testFnWrapper; } });
const testInterfaceWrapper_1 = require("./testInterfaceWrapper");
Object.defineProperty(exports, "runTestInFiberContext", { enumerable: true, get: function () { return testInterfaceWrapper_1.runTestInFiberContext; } });
